import User from "../core/User";
import { SystemFileType } from "../enums/SystemFileType";
import File from "../files/File";

export class RecycledItem {
    id: string;
    code: string;
    name: string;
    recycledOn: Date;
    recycledBy: string;
    raw: File;

    constructor(data: Partial<RecycledItem>, users: User[]);
    constructor(data: File, users: User[]);
    constructor(data: Partial<RecycledItem> | File, users: User[]) {
        if ("fileType" in data) {
            const temp = data as File;
            switch (temp.fileType) {
                case SystemFileType.TimetableFile:
                    this.id = `T-${temp.id}`;
                    this.code = "TDF";
                    break;
                case SystemFileType.StudentOptionsFile:
                    this.id = `S-${temp.id}`;
                    this.code = "SDF";
                    break;
                case SystemFileType.DailyOrganiserFile:
                    this.id = `D-${temp.id}`;
                    this.code = "DOF";
                    break;
                case SystemFileType.Folder:
                    this.id = `F-${temp.id}`;
                    this.code = "Folder";
                    break;
                default:
                    this.id = `${temp.id}`;
                    this.code = "Unknown";
                    break;
            }
            this.name = temp.name;
            this.recycledOn = temp.recycledOn?.toDate();
            this.recycledBy =
                users.find(u => u.id === temp.recycledBy)?.username ??
                "Unknown";
            this.raw = temp;
        } else {
            Object.assign(this, data);
        }
    }
}
